import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { Info } from 'lucide-react';
import { Label } from '@/components/ui/label';
import { NULL_VALUE } from '@/constants/displayConstants';

function InfoBlock(props: { label: string; value?: string }) {
  return (
    <div className="tw:w-1/2">
      <Label className="tw:text-xs">{props.label}</Label>
      <p>{props.value ?? NULL_VALUE}</p>
    </div>
  );
}

export function CardOperationalPeriod() {
  return (
    <Card className="tw:w-1/3 tw:bg-transparent" size="sm">
      <CardHeader>
        <CardTitle className="tw:flex tw:items-center tw:justify-between">
          <span>2. Operational Period</span>
          <Tooltip>
            <TooltipTrigger>
              <Info size={16} />
            </TooltipTrigger>
            <TooltipContent>
              <p>
                This section is read-only. It is automatically filled from the
                planned next operational period start and end time.
              </p>
            </TooltipContent>
          </Tooltip>
        </CardTitle>
      </CardHeader>
      <CardContent className="tw:grid tw:grid-cols-2 tw:gap-2">
        <InfoBlock label="From" />
        <InfoBlock label="To" />
      </CardContent>
    </Card>
  );
}
